import { useFirestore } from '@/services';
import * as App from '@/types/app';
import * as Database from '@/types/database';
import { defineFirebaseCollectionStoreModule } from './base-module';

const { useTruckOperators } = useFirestore();
export const trucksModule = defineFirebaseCollectionStoreModule<App.Truck, Database.Truck>(useTruckOperators);
